export const createEntity = (field, valueToOrder = "name", mutate = false) => entity => state => {
  if (!mutate) {
    return {
      [field]: [...state[field], entity].sort((a, b) => (
        a[valueToOrder].localeCompare(b[valueToOrder])
      ))
    };
  }

  return [
    ...state,
    entity
  ].sort((a, b) => {
    if (typeof a[valueToOrder] === "number") return a[valueToOrder] - b[valueToOrder];
    return a[valueToOrder].localeCompare(b[valueToOrder]);
  });
};

export const updateEntity = (field, mutate = false) => entity => state => {
  if (!mutate) {
    return {
      [field]: state[field].map(current => (
        current.id === entity.id ? entity : current
      ))
    };
  }

  return [
    ...state.map(current => (
      current.id === entity.id ? entity : current
    ))
  ];
};

export const updateChildEntity = field => entity => state => ({
  [field]: state[field].map(current => (
    current.id === entity.parentStoryQuestion?.id
      ? ({
        ...current,
        childStoryQuestions: current.childStoryQuestions.map(
          child => (child.id === entity.id ? entity : child))
      }) : current
  ))
});

export const replaceEntity = field => (entity, id) => state => ({
  [field]: state[field].map(current => (
    current.id === id ? entity : current
  ))
});

export const deleteEntity = (field, mutate = false) => entity => state => {
  if (!mutate) {
    return {
      [field]: state[field].filter(current => current.id !== entity.id)
    };
  }

  return [
    ...state.filter(current => current.id !== entity.id)
  ];
};

export const deleteChildEntity = field => entity => state => ({
  [field]: state[field].map(current => (
    current.id === entity.parentStoryQuestion?.id
      ? ({
        ...current,
        childStoryQuestions: current.childStoryQuestions.filter(
          child => child.id !== entity.id)
      }) : current
  ))
});
